/**
 * Anzeige-Ende einer Offline-Periode aus shifts/{datum}.drivers.{uid}.shifts[].offlinePeriods.
 *
 * Beim Abmelden öffnet endDriverShift (Cloud Functions) eine Periode mit offlineEnd: null.
 * Meldet sich der Fahrer innerhalb von 12 h nach Schichtbeginn wieder an, nimmt die App
 * (_shouldStartNewShift) bzw. das Portal (driversSlice) die Schicht wieder auf und schließt
 * die Periode — sie markiert dann die Lücke in der Schicht. Nach Ablauf dieses Fensters
 * kann die Schicht nicht mehr fortgesetzt werden; eine noch offene Periode ist dann nur
 * noch ein Überbleibsel des Feierabends und darf nicht weiter „bis jetzt“ laufen.
 */

// Muss zum Fenster in home_driver.dart (_shouldStartNewShift) und driversSlice passen.
export const SHIFT_RESUME_WINDOW_MS = 12 * 60 * 60 * 1000;

/**
 * @param {object} params
 * @param {Date} params.offlineStart
 * @param {Date|null} params.offlineEnd
 * @param {Date|null} params.shiftStart
 * @param {Date} [params.now]
 * @returns {{ endTime: Date, isOpen: boolean }} isOpen: Die Schicht kann noch fortgesetzt
 *   werden, die Periode läuft also tatsächlich noch.
 */
export const effectiveOfflineEnd = ({ offlineStart, offlineEnd, shiftStart, now = new Date() }) => {
  if (offlineEnd) return { endTime: offlineEnd, isOpen: false };

  const resumeDeadline = shiftStart
    ? new Date(shiftStart.getTime() + SHIFT_RESUME_WINDOW_MS)
    : null;
  const isOpen = !resumeDeadline || now < resumeDeadline;
  const cap = isOpen ? now : resumeDeadline;
  // Abmeldung erst nach Ablauf des Fensters: Periode schrumpft auf ihren Beginn.
  const endTime = offlineStart && cap < offlineStart ? offlineStart : cap;
  return { endTime, isOpen };
};
